import { useInView } from '@/hooks/useInView';
import { ArrowRight, Zap } from 'lucide-react';

export default function HeroSection() {
  const [ref, inView] = useInView();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" ref={ref} data-testid="hero-section" className="relative min-h-screen flex items-center pt-20 overflow-hidden">
      {/* Gradient orbs */}
      <div className="absolute top-1/4 -left-32 w-[400px] h-[400px] rounded-full bg-purple-400/15 blur-[120px]" />
      <div className="absolute bottom-1/4 -right-32 w-[400px] h-[400px] rounded-full bg-pink-400/15 blur-[120px]" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-indigo-400/8 blur-[150px]" />

      <div className={`max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-24 lg:py-32 ${inView ? 'animate-fade-in-up' : 'opacity-0'}`}>
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/60 backdrop-blur-xl border border-white/80 shadow-sm mb-8">
            <Zap size={14} className="text-purple-600" />
            <span className="text-xs font-semibold tracking-[0.15em] uppercase text-purple-600 font-['Outfit']">
              Website as a Service
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter text-slate-900 font-['Outfit'] leading-[1.05]">
            Webpräsenz als Service.
            <br />
            <span className="gradient-text font-normal">
              Wie Strom aus der Steckdose.
            </span>
          </h1>

          <p className="mt-8 text-base lg:text-lg text-slate-500 max-w-2xl leading-relaxed">
            Professionelle Websites für Klein- und Mittelständische Unternehmen &mdash;
            ohne technischen Aufwand, ohne versteckte Kosten. Einfach online sein.
          </p>

          <div className="mt-12 flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo('kontakt')}
              className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-500 text-white font-medium shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40 transition-all pulse-glow"
              data-testid="hero-cta-button"
            >
              Verbindung herstellen
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollTo('pakete')}
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white/80 backdrop-blur-md border border-slate-200 text-slate-700 font-medium hover:bg-white transition-all"
              data-testid="hero-packages-button"
            >
              Pakete entdecken
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
